'use strict';

var Sugar = require('sugar-core'),
    getWeekday = require('./internal/getWeekday');

Sugar.Date.defineInstance({

  'getWeekday': function(date) {
    return getWeekday(date);
  }

});

module.exports = Sugar.Date.getWeekday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/getWeekday.js
// module id = 503
// module chunks = 0